import axios from "../../../utils/authAxios";
const api_base_url =
  process.env.REACT_APP_API_BASEURL + "/OperationsGroup/OperationsGroup";

// Update Operations Group
export const editOperationsGroup = async (editOperationsGroupData) => {
  const { data } = await axios.put(api_base_url, editOperationsGroupData);
  return data;
};

// Insert New Operations Group
export const addOperationsGroup = async (newOperationsGroup) => {
  const { data } = await axios.post(api_base_url, {
    ...newOperationsGroup,
  });
  return data;
};

// Delete Operation Group
export const deleteOperationsGroup = async (ids) => {
  return axios.delete(api_base_url, {
    data: ids,
  });
};
